/**
* 首页
*/ 
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
    </el-breadcrumb>

      <div style="margin-top: 15px;margin-left: 10px">当前日期：{{ nowDate }}</div>

      <div style="margin-top: 10px;margin-left: 10px">流量统计表格下载：</div>
      <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="目标：">
        <el-select size="small" v-model="formInline.goal" style="width:100px" placeholder="请选择">
          <el-option v-for="type in goalData" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 截止时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择开始时间" style="width: 150px;"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择结束时间" style="width: 150px;"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="download">下载</el-button>
      </el-form-item>
    </el-form>

    <!-- 统计图 -->
    <div>
    <el-row :gutter="23">
      <el-col :span="8" class="text-c">
        <div class="st-gbox">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>其知网</span>
            </div>
            <div class="box-card-body">
              <div class="text item">
                今日访问：{{ census.indexNowUserNum }}
              </div>
              <div class="text item">
                新增用户：{{ census.indexNewUserNum }}
              </div>
              <div class="text item">
                本月累计：{{ census.indexMonthUserNum }}
              </div>
              <div class="text item">
                历史累计：{{ census.indexTotalUserNum }}
              </div>
               <div class="text item">
                累计PDF订单数量：{{ census.indexTotalPdfFeeOrderNum }}
              </div>
              <div class="text item">
                累计PDF订单金额：{{ census.indexTotalPdfFeeOrderPrice }}
              </div>
            </div>

            <div class="box-card-body">
              <div class="text item">
                今日年费订单数量：{{ census.indexNowAnFeeOrderNum }}
              </div>
              <div class="text item">
                今日年费订单金额：{{ census.indexNowAnFeeOrderPrice }}
              </div>
              <div class="text item">
                本月年费订单数量：{{ census.indexMonthAnFeeOrderNum }}
              </div>
              <div class="text item">
                本月年费订单金额：{{ census.indexMonthAnFeeOrderPrice }}
              </div>
              <div class="text item">
                累计年费订单数量：{{ census.indexTotalAnFeeOrderNum }}
              </div>
              <div class="text item">
                累计年费订单金额：{{ census.indexTotalAnFeeOrderPrice }}
              </div>
            </div>

          </el-card>
        </div>
      </el-col>
      <el-col :span="8" class="text-c">
        <div class="st-gbox">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>专利卫士</span>
            </div>
            <div class="box-card-body">
              <div class="text item">
                今日访问：{{ census.apiNowUserNum }}
              </div>
              <div class="text item">
                新增用户：{{ census.apiNewUserNum }}
              </div>
              <div class="text item">
                本月累计：{{ census.apiMonthUserNum }}
              </div>
              <div class="text item">
                历史累计：{{ census.apiTotalUserNum }}
              </div>
              <div class="text item">
                累计PDF订单数量：{{ census.apiTotalPdfFeeOrderNum }}
              </div>
              <div class="text item">
                累计PDF订单金额：{{ census.apiTotalPdfFeeOrderPrice }}
              </div>
            </div>

            <div style="width: 49%;text-align: left;float: left;">
              <div class="text item">
                今日年费订单数量：{{ census.apiNowAnFeeOrderNum }}
              </div>
              <div class="text item">
                今日年费订单金额：{{ census.apiNowAnFeeOrderPrice }}
              </div>
              <div class="text item">
                本月年费订单数量：{{ census.apiMonthAnFeeOrderNum }}
              </div>
              <div class="text item">
                本月年费订单金额：{{ census.apiMonthAnFeeOrderPrice }}
              </div>
              <div class="text item">
                累计年费订单数量：{{ census.apiTotalAnFeeOrderNum }}
              </div>
              <div class="text item">
                累计年费订单金额：{{ census.apiTotalAnFeeOrderPrice }}
              </div>
            </div>

          </el-card>
        </div>
      </el-col>
      <el-col :span="8" class="text-c">
        <div class="st-gbox">
          <el-card class="box-card">
            <div slot="header" class="clearfix" style="height: 21px;">
              <span></span>
            </div>
            <div class="box-card-body">
              <div class="text item">
                其知创新今日访问：{{ census.qzcxNowUserNum }}
              </div>
            </div>
             <div class="box-card-body">
              <div class="text item">
                年费接口剩余次数：{{ census.feeRemainNum }}
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    </div>

  <el-form :inline="true" :model="formTotal" style="margin-top: 50px;">
      <el-form-item label="时间段：">
      </el-form-item>
      <!-- 截止时间 -->
      <el-form-item>
        <el-date-picker v-model="formTotal.beginDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择开始时间" style="width: 150px;"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="formTotal.endDate" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择结束时间" style="width: 150px;"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <span style="color: #C0C4CC;">不选择时间默认显示近30天内的统计数据</span>
      </el-form-item>
    </el-form>
  <div style="margin-top: 30px;">
    <div id="report" style="width: 100%;min-height: 400px;"></div>
  </div>
  </div>
 


</template>
<script type="text/ecmascript-6">
import { indexCensus, getVisitCensus, getVisitCensusV2, downloadVisitExcel } from '../../api/userMG'
import { getCurrentDate, checkLogin } from '../../utils/util'
import * as echarts from 'echarts';

export default {
  
  
  data() {

   return {
      nowDate: getCurrentDate(),
      census: [],
      clientHeight: document.body.clientHeight,
      clientWidth: document.body.clientWidth,
      formInline:{
        goal: '',
        start_time: '',
        end_time: ''
      },
      formTotal:{
        beginDate: '',
        endDate: ''
      },
      goalData: [
        { key: '其知网', value: 1 },
        { key: '专利卫士', value: 2 },
        { key: '其知创新', value: 3 }
      ],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      visitData:{
        totalNum: 0
      },
      listData:{},
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },

      charts: "",
      option: {
          title: {
          left: 'left',
          text: '流量统计'
          },
          legend: {
            data: ['其知网流量统计', '专利卫士流量统计', '其知创新流量统计']
          },
          xAxis: {
              type: 'category',
              data: [],
          },
          yAxis: {
              type: 'value'
          },
          series: [{
              name: '其知网流量统计',
              data: [],
              type: 'line',
              itemStyle: {
                normal: { label: {show: true} }
              }
          },{
              name: '专利卫士流量统计',
              data: [],
              type: 'line',
              itemStyle: {
                normal: { label: {show: true}}
              }
          },{
              name: '其知创新流量统计',
              data: [],
              type: 'line',
              itemStyle: {
                normal: { label: {show: true}}
              }
          }],
          tooltip: {
             trigger: 'axis',
             label: {
                    backgroundColor: '#6a7985'
              }
          }
      },
  
     
        
   }
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
    // this.mounted()
  },

  // 里面的函数只有调用才会执行
  methods: {
    getdata() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      indexCensus()
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
            this.census = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误!')
        })
    },
    download() {
      // 下载访问量表格
      if(this.formInline.goal.length <= 0){
              this.$message({
                type: 'error',
                message: '下载目标不能为空'
              })
              return false
          }
      if(this.formInline.start_time.length <= 0){
              this.$message({
                type: 'error',
                message: '开始时间不能为空'
              })
              return false
          }
        if(this.formInline.end_time.length <= 0){
            this.$message({
              type: 'error',
              message: '结束时间不能为空'
            })
            return false
        }
      
       downloadVisitExcel(this.formInline)
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '下载成功~'
            })
            window.location.href = res.data.url;
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误!')
        })
    },

    drawBroken(id) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption(this.option)
    },
    search(){
      if(this.formTotal.beginDate == null){
          this.formTotal.beginDate = '';
      }
      if(this.formTotal.endDate == null){
          this.formTotal.endDate = '';
      }
       getVisitCensusV2(this.formTotal)
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
           this.option.xAxis.data = res.data.xDate
           this.option.series[0].data = res.data.yData1
           this.option.series[1].data = res.data.yData2
           this.option.series[2].data = res.data.yData3
          //  console.log(res.data.xDate)
          //  console.log(res.data.yData)
            // console.log(this.visitData)
           this.drawBroken("report");

          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误!')
        })
    }
  },
  mounted() {
    this.$nextTick(function() {
      // this.option.xAxis.data = ['2021.09.01', '2021.09.02', '2021.09.03', '2021.09.04', '2021.09.05', '2021.09.06', '2021.09.07',
      //         '2021.09.08','2021.09.09','2021.09.10'];
      // this.option.series[0].data =  [150, 230, 224, 218, 135, 147, 260, 250, 240, 260]; 
      // 调用接口请求数据

      getVisitCensusV2(this.formTotal)
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
           this.option.xAxis.data = res.data.xDate
           this.option.series[0].data = res.data.yData1
           this.option.series[1].data = res.data.yData2
           this.option.series[2].data = res.data.yData3
          //  console.log(res.data.xDate)
          //  console.log(res.data.yData)
            // console.log(this.visitData)
           this.drawBroken("report");

          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误!')
        })
    });
  }
};
</script>
<style>
.stbox {
  width: 100%;
  /* height: 100%; */
  box-sizing: border-box;
}
.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}
.stsearch {
  text-align: center;
}
.text-c {
  text-align: center;
}
.st-gbox {
  background-color: #fff;
  /* margin-top: 20px; */
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}
.st-gbox-one {
  background-color: red;
}
.st-gbox-two {
  background-color:skyblue;
}
.st-gbox-three {
  background-color:springgreen;
}
.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
.headerOne {
  top: 18px;
}
input{ outline:none; border:0; }

.text {
    font-size: 14px;
}

.item {
  margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}
.el-card__header {
  background-color: #4ed9e4;
}
.box-card-body {
  width: 45%;
  text-align: left;
  float: left;
  padding-left: 20px;
}
.user-search {
  margin-left: 10px;
  margin-top: 10px;
}
.el-form--inline .el-form-item {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue